module.exports = __webpack_public_path__ + "img/close.9a4005db.png";